import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { makeHeadData, makeRowColumn } from 'lib/commonLib';
import { viAccountStatistics, viAccountTot } from 'lib/api/sales';

import FilterWrap from 'components/atoms/FilterWrap';
import TableContainer from 'components/molecules/MbTable';
import BasicTable from 'components/molecules/MbBasicTable';
import Popover from 'components/molecules/Popover';
import SwitchingArea from 'components/organisms/SwitchingArea';

let initParam = {};

const Statistics = () => {
  const { t } = useTranslation();
  const [params, setParams] = useState(initParam);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterValue, setFilterValue] = useState({
    acctSt: '0',
  });
  const acctStList = [
    { value: '0', label: t('전체') },
    { value: '1', label: t('발행') },
    { value: '2', label: t('대기') },
  ];

  const TotHeadList = [
    {
      id: 'STATE',
      label: t('상태'),
      type: 'string',
      format: '@',
      displayFlag: true,
    },
    {
      id: 'PUBLISH',
      label: t('발행'),
      type: 'number',
      format: '#,##0',
      displayFlag: true,
    },
    {
      id: 'WAIT',
      label: t('대기'),
      type: 'number',
      format: '#,##0',
      displayFlag: true,
    },
    {
      id: 'TOTAL',
      label: t('합계'),
      type: 'number',
      format: '#,##0',
      displayFlag: true,
    },
  ];

  useEffect(() => {
    setLoading(true);
    viAccountTot()
      .then((response) => {
        const { data } = response.data;
        setList(data);
        setLoading(false);
      })
      .catch((error) => {
        alert('error');
      });
  }, []);

  const totCustomized = {
    STATE: {
      makeBody: (rowObj) => {
        return (
          <>
            <div className={'center'}>{makeRowColumn(rowObj['STATE'])}</div>
          </>
        );
      },
    },
    PUBLISH: {
      makeBody: (rowObj) => {
        return (
          <>
            <div className={'center'}>{makeRowColumn(rowObj['PUBLISH'])}</div>
          </>
        );
      },
    },
    WAIT: {
      makeBody: (rowObj) => {
        return (
          <>
            <div className={'center'}>{makeRowColumn(rowObj['WAIT'])}</div>
          </>
        );
      },
    },
    TOTAL: {
      makeBody: (rowObj) => {
        return (
          <>
            <div className={'center'}>{makeRowColumn(rowObj['TOTAL'])}</div>
          </>
        );
      },
    },
  };
  const customized = {
    VIRTUAL_ACCOUNT_NUMBER: {
      makeBody: (rowObj) => {
        return (
          <>
            <p className={'center'}>
              {makeRowColumn(rowObj['VIRTUAL_ACCOUNT_NUMBER'])}
            </p>
          </>
        );
      },
    },
  };

  const handleOnchangeFilter = (props) => {
    const { name, value } = props.target;

    setFilterValue({
      ...filterValue,
      [name]: value,
    });

    setParams({
      ...params,
      [name]: value === '0' ? null : value,
    });
  };
  return (
    <>
      <div style={{ marginBottom: 15 }}>
        {list && (
          <BasicTable
            list={list}
            sort={'asc'}
            order={'LABEL'}
            headCells={makeHeadData(TotHeadList)}
            loading={loading}
            customized={totCustomized}
            virtualAccount={true}
          />
        )}
      </div>
      <SwitchingArea title={t('계좌상태')}>
        <FilterWrap>
          <Popover
            name="acctSt"
            label={t('계좌상태')}
            // getOnClose={getOnClose}
            selectedLabel={
              filterValue.acctSt === '1'
                ? '발행'
                : filterValue.acctSt === '2' && '대기'
            }
            filtered={filterValue.acctSt !== '0'}
            filterType="radio"
            optionSelectedValue={filterValue.acctSt}
            optionList={acctStList}
            optionOnChange={handleOnchangeFilter}
          />
        </FilterWrap>
        <>
          <TableContainer
            dataReqPromise={viAccountStatistics}
            params={{ ...params }}
            sort="desc"
            order="STATS_DTTM"
            dense={true}
            noneSearch={true}
            customized={customized}
          />
        </>
      </SwitchingArea>
    </>
  );
};

export default withRouter(Statistics);
